import styled, { css } from 'styled-components/macro';
import React from 'react';
import { Link } from 'react-router-dom';
import { getFeaturesEnabled } from '../slaughterhouseSpecific';

export const Breadcrumbs = ({ wrapperStyle, breadcrumbs, ...props }) => {
  if (!getFeaturesEnabled().breadcrumbs) {
    return null;
  }
  return (
    <div css={css`display: flex; ${wrapperStyle}`}>
      {[{ title: 'Hjem', url: '/' }].concat(breadcrumbs).map((bc, idx, arr) => (
        <div key={idx} css={css`display: flex;`}>
          <Link
            to={{ pathname: bc.url }}
            css={css`
                        font-weight: bold;
                        color: #4a4a4a;
                        font-size: 0.95rem;
                        text-decoration: underline;
                        text-decoration-color: ${idx + 1 === arr.length ? 'transparent' : '#4a4a4a'};
                        &:hover{
                            cursor: pointer;
                        }
                    `}
          >
            {bc.title}
          </Link>
          {idx + 1 !== arr.length
                        && (
                          <div css={css`
                            background: gray;
                            transform: rotate(20deg);
                            margin-left: 0.75rem;
                            margin-right: 0.75rem;
                            height: 0.65rem;
                            margin-top: auto;
                            margin-bottom: 0.22rem;
                            width: 1.4px;
                        `}
                          />
                        )}
        </div>
      ))}
    </div>
  );
};
